import React from "react";
import { useCart } from "../context/CartContext";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "../styles/CartPage.css";

// Optional: ETH to USD conversion if you want to recalc from ETH
const ETH_TO_USD = 1850;

// Parse ETH string to number, e.g., "0.034 ETH" -> 0.034
const priceToNumber = (p) => {
  if (!p) return 0;
  return parseFloat(p.replace("ETH", "").trim()) || 0;
};

const CartPage = () => {
  const { cart, removeFromCart, clearCart } = useCart();

  // Calculate totals using priceETH
  const totalEth = cart.reduce((sum, it) => sum + priceToNumber(it.priceETH), 0);
  const totalUsd = cart.reduce((sum, it) => sum + priceToNumber(it.priceETH) * ETH_TO_USD, 0);

  return (
    <Container className="cart-page">
      <div className="cart-header d-flex justify-content-between align-items-center mb-3">
        <h2>Your Cart</h2>
        <div>
          <span className="total me-2">
            Total: {totalEth.toFixed(2)} ETH (${totalUsd.toFixed(2)})
          </span>
          {cart.length > 0 && (
            <Button variant="outline-danger" size="sm" onClick={clearCart}>
              Clear Cart
            </Button>
          )}
        </div>
      </div>

      {cart.length === 0 ? (
        <p className="cart-empty">No items in cart.</p>
      ) : (
        <Row xs={1} sm={2} md={3} className="g-4">
          {cart.map((nft, idx) => {
            const nftEth = priceToNumber(nft.priceETH);
            const nftUsd = nftEth * ETH_TO_USD;

            return (
              <Col key={`${nft.id}-${idx}`}>
                <Card className="cart-card h-100 shadow-sm">
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      paddingTop: "100%",
                      overflow: "hidden",
                      background: "#111",
                    }}
                  >
                    <img
                      src={nft.image}
                      alt={nft.name}
                      style={{
                        position: "absolute",
                        inset: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <Card.Body className="d-flex flex-column">
                    <Card.Title className="text-truncate mb-1">{nft.name}</Card.Title>
                    <Card.Text className="text-muted mb-2">By {nft.artist}</Card.Text>
                    <Card.Text className="fw-bold mb-3">
                      {nftEth.toFixed(2)} ETH (${nftUsd.toFixed(2)})
                    </Card.Text>
                    <Button
                      variant="outline-danger"
                      className="mt-auto"
                      onClick={() => removeFromCart(nft.id)}
                    >
                      Remove
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      )}
    </Container>
  );
};

export default CartPage;
